import React from 'react';
import classes from './style.module.scss';
import Header from '../Header/Header';
import Poster from '../../media/header.png';
import Intro from '../../media/intro.mp4';
import Info from '../Info/Info';
import GamePrice from '../GamePrice/GamePrice';
import RussianBall from '../../media/russian.svg';
import AmericanBall from '../../media/pool.svg';
import Hall from '../Hall/Hall';
import Reviews from '../Reviews/Reviews';
import Footer from '../Footer/Footer';
import ScrollButton from '../ScrollButton/ScrollButton';

const Main = () => {
    const priceListRussian = [
        {
            time: '13:00 - 15:00',
            price: '500 р/ч',
        },
        {
            time: '15:00 - 18:00',
            price: '600 р/ч',
        },
        {
            time: '18:00 - 01:00',
            price: '700 р/ч',
        },
        {
            time: 'c 01:00',
            price: '950 р/ч',
        },
    ];

    const priceListRussianWeekend = [
        {
            time: '11:00 - 18:00',
            price: '600 р/ч',
        },
        {
            time: '18:00 - 01:00',
            price: '700 р/ч',
        },
        {
            time: 'c 01:00',
            price: '950 р/ч',
        },
    ];

    const priceListAmerican = [
        {
            time: '13:00 - 15:00',
            price: '400 р/ч',
        },
        {
            time: '15:00 - 18:00',
            price: '500 р/ч',
        },
        {
            time: '18:00 - 01:00',
            price: '600 р/ч',
        },
        {
            time: 'c 01:00',
            price: '850 р/ч',
        },
    ];

    const priceListAmericanWeekend = [
        {
            time: '11:00 - 17:00',
            price: '500 р/ч',
        },
        {
            time: '18:00 - 01:00',
            price: '600 р/ч',
        },
        {
            time: 'c 01:00',
            price: '850 р/ч',
        },
    ];

    return (
        <div>
            <div className={classes.container}>
                <Header />
                {/^((?!chrome|android).)*safari/i.test(navigator.userAgent) ? (
                    <img className={classes.poster} src={Poster} alt="poster" />
                ) : (
                    <video
                        className={classes.video}
                        controls={false}
                        loop={true}
                        muted={true}
                        playsInline={true}
                        poster={Poster}
                        autoPlay={true}
                    >
                        <source src={Intro} type="video/mp4" />
                    </video>
                )}
                <Info />
                <div className={classes.prices}>
                    <GamePrice
                        image={RussianBall}
                        priceList={priceListRussian}
                        priceListWeekend={priceListRussianWeekend}
                        size={'12 футов'}
                        tables={'7 столов'}
                        tableName={'Русская пирамида'}
                        tableInfo={
                            'Русский бильярд - это увлекательный и динамичный вид спорта, который зародился в России более 200 лет назад. В то время бильярд был популярен только у знати и богатых людей, которые играли исключительно в закрытых клубах и на замках. С течением времени, бильярд стал доступен широкой публике и стал одним из самых популярных видов спорта в России.'
                        }
                    />
                    <GamePrice
                        image={AmericanBall}
                        priceList={priceListAmerican}
                        priceListWeekend={priceListAmericanWeekend}
                        size={'8, 9 футов'}
                        tables={'2 стола'}
                        tableName={'Американский пул'}
                        tableInfo={
                            'Американский пул появился в США в конце 19 века. В пул начали играть в США во время Великой выставки в 1876 году. Не смотря на кажущуюся простоту, является одной из самых сложных разновидностей бильярда. Это не только игра на удачу, но и на ловкость и стратегию. Нужно не только забивать шары, но и накапливать позицию для следующих ударов.'
                        }
                    />
                </div>
                <Hall />
                <Reviews />
            </div>
            <Footer />
            <ScrollButton />
        </div>
    );
};

export default Main;
